module.exports = __webpack_public_path__ + "static/media/unionpay.af9882d1.svg";